module.exports = __webpack_public_path__ + "static/media/empty.23b93484.svg";